import React from 'react';
import { Provider } from 'react-redux';
import { ErrorReporting } from 'mm-ui-components';
import { Store } from 'redux';
import { Helmet } from 'react-helmet';
import { ErrorReporter } from '../errorReporting/errorReporter.type';
import { AppActions, AppState } from '../store/initialStateRegistration';
import { CoreWebVitals } from '../components/coreWebVitals/CoreWebVitals';

interface PageProps {
  store: Store<AppState, AppActions>;
  errorProvider: ErrorReporter;
}

export const Page: React.FunctionComponent<PageProps> = ({ store, children, errorProvider }) => {
  const { locale } = store.getState().config;
  return (
    <React.Fragment>
      <Helmet>
        <html lang={locale} />
      </Helmet>
      <Provider store={store}>
        <ErrorReporting.Provider value={errorProvider}>
          <CoreWebVitals />
          {children}
        </ErrorReporting.Provider>
      </Provider>
    </React.Fragment>
  );
};
